<a
  [rivetLink]="url"
  [activeClass]="true"
  [activeExact]="exact"
  [locked]="locked"
  [class.locked]="locked"
>
  <riv-icon
    class="lock-icon"
    [name]="'Lock'"
    *ngIf="locked"
    [size]="16"
  ></riv-icon>
  <span><ng-content></ng-content></span>
</a>
